let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cMCZv")).then(() => parcelRequire('3Q9j6'));